import { Link } from "react-router-dom";
import { formatEUR } from "../lib/api";
import Placeholder from "./Placeholder";

const ProductCard = ({ product, className = "", fill = false }) => (
  <Link
    to={`/produit/${product.slug}`}
    data-testid={`product-card-${product.slug}`}
    className={`group flex flex-col ${className}`}
  >
    <div className={`relative overflow-hidden bg-panel border border-line group-hover:border-lineActive transition-colors duration-500 ${fill ? "h-[440px] sm:h-[560px]" : "aspect-[4/5]"}`}>
      {product.images && product.images[0] ? (
        <img
          src={product.images[0]}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
          loading="lazy"
        />
      ) : (
        <div className="w-full h-full transition-transform duration-700 group-hover:scale-[1.03]">
          <Placeholder label={product.name} />
        </div>
      )}
      {product.featured && (
        <span className="absolute top-3 left-3 bg-ink/80 backdrop-blur px-3 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-gold border border-gold/30">
          Iconique
        </span>
      )}
      {product.customizable && (
        <span className="absolute top-3 right-3 bg-ink/80 backdrop-blur px-3 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-white border border-white/40">
          Personnalisable
        </span>
      )}
      <span className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-white text-ink font-mono text-[10px] uppercase tracking-[0.25em] px-3 py-1.5">
        Voir la pièce
      </span>
    </div>
    <div className="pt-4 flex items-start justify-between gap-4">
      <div>
        <h3 className="font-grotesk font-semibold uppercase tracking-wider text-sm sm:text-base text-neutral-100 group-hover:text-white transition-colors">
          {product.name}
        </h3>
        <div className="mt-1.5 flex items-center gap-1.5">
          {product.colors.map((c) => (
            <span key={c} title={c} className="w-2.5 h-2.5 rounded-full border border-lineActive bg-neutral-400" />
          ))}
        </div>
      </div>
      <p className="font-mono text-sm text-silver whitespace-nowrap">{formatEUR(product.price)}</p>
    </div>
  </Link>
);

export default ProductCard;
